import { TYPE_ERROR, TYPE_INFO, TYPE_WARNING } from './toastNotification';
import { StCloseIcon, StNotification, StNotificationIcon, StNotificationText } from './customNotification.styled';
import { toast } from 'sonner';

export type NotificationType = typeof TYPE_ERROR | typeof TYPE_INFO | typeof TYPE_WARNING;

interface Props {
    type: NotificationType;
    id: number | string;
    message: string;
}
export const CustomNotification = ({ type, id, message }: Props) => {
    return (
        <div data-displayname="Notification">
            <StNotification key={id} type={type ?? ''} data-testid="notification-info">
                <StNotificationIcon className="material-icons" type={type ?? ''}>
                    {getIcon(type)}
                </StNotificationIcon>
                <StNotificationText dangerouslySetInnerHTML={{ __html: message ?? '' }} type={type ?? ''} />
                {type === TYPE_ERROR ? (
                    <StCloseIcon title="close" className="material-icons" onClick={() => toast.dismiss(id)}>
                        close
                    </StCloseIcon>
                ) : null}
            </StNotification>
        </div>
    );
};

export const getIcon = (type: NotificationType) => {
    switch (type) {
        case TYPE_WARNING:
            return 'error_outline';
        case TYPE_ERROR:
            return 'block';
        case TYPE_INFO:
            return 'check';
        default:
            return null;
    }
};
